export default __webpack_public_path__ + "static/media/about-credit-banner.c7b6ad3d.jpg";